import { render, staticRenderFns } from "./DashboardOverview2.vue?vue&type=template&id=78c0e761&scoped=true&"
import script from "./DashboardOverview2.vue?vue&type=script&lang=js&"
export * from "./DashboardOverview2.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOverview2.vue?vue&type=style&index=0&id=78c0e761&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0e761",
  null
  
)

export default component.exports